import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getBeachCleaningList as getBeachCleaningListApi,
	getBeachCleaning as getBeachCleaningApi,
	addNewBeachCleaning as addNewBeachCleaningApi,
	updateBeachCleaning as updateBeachCleaningApi,
	deleteBeachCleaning as deleteBeachCleaningApi,
	getBeachCleaningData as getBeachCleaningDataApi,
	registerBeachCleaning as registerBeachCleaningApi,
} from '../../helpers/residue/backend_helper';

export const getBeachCleaningList = createAsyncThunk('beachCleanings/getBeachCleaningList', async (params) => {
	try {
		const response = getBeachCleaningListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getBeachCleaning = createAsyncThunk('beachCleanings/getBeachCleaning', async beachCleaningId => {
	try {
		const response = getBeachCleaningApi(beachCleaningId);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewBeachCleaning = createAsyncThunk('beachCleanings/addNewBeachCleaning', async beachCleaning => {
	try {
		const response = addNewBeachCleaningApi(beachCleaning);
		toast.success('BeachCleaning agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar limpieza de playa.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateBeachCleaning = createAsyncThunk('beachCleanings/updateBeachCleaning', async (beachCleaning) => {
		try {
			const response = updateBeachCleaningApi(beachCleaning);
			toast.success('BeachCleaning actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar limpieza de playa.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteBeachCleaning = createAsyncThunk('beachCleanings/deleteBeachCleaning', async beachCleaning => {
	try {
		const response = await deleteBeachCleaningApi(beachCleaning);
		toast.success('BeachCleaning eliminado exitosamente.', { autoClose: 3000 });
		return { beachCleaning, ...response };
	} catch (error) {
		toast.error('Error al eliminar limpieza de playa.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const getBeachCleaningData = createAsyncThunk('beachCleanings/getBeachCleaningData', async beachCleaning => {
	try {
		const response = await getBeachCleaningDataApi(beachCleaning);
		console.log(response)
		return response;
	} catch (error) {
		console.log(error)
		toast.error('Error al obtener datos de limpieza de playa.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const registerBeachCleaning = createAsyncThunk('beachCleanings/registerBeachCleaning', async beachCleaning => {
	try {
		const response = await registerBeachCleaningApi(beachCleaning);
		toast.success(`Limpieza de playa ${beachCleaning?.id ? 'actualizada' : 'registrada'} exitosamente.`, { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al registrar limpieza de playa.', { autoClose: 3000 });
		throw new Error(error);
	}
});